module.exports = __webpack_public_path__ + "static/media/NYE.b6c282d4.jpg";